import Vue from 'vue'
import Router from 'vue-router'
import defaultPage from '@/layout/default.vue'

Vue.use(Router)

export default new Router({
	// mode: 'history',
	routes: [{
		path: '/',
		name: 'defaultPage',
		redirect: '/index',
		component: defaultPage,
		children: [{
				path: '/index',
				name: 'index',
				component: () => import('@/pages/index/indexbeiyong.vue')
			},
			{
				path: '/serve',
				name: 'index2',
				component: () => import('@/pages/xiangqing/serve.vue')
			},
			{
				path: '/successStories',
				name: 'successStories',
				component: () => import('@/pages/xiangqing/successStories.vue')
			},
			{
				path: '/singleNews',
				name: 'singleNews',
				component: () => import('@/pages/xiangqing/singleNews.vue')
			},
			{
				path: '/newsList',
				name: 'newsList',
				component: () => import('@/pages/xiangqing/newsList.vue')
			},
			{
				path: '/joinUs',
				name: 'joinUs',
				component: () => import('@/pages/xiangqing/joinUs.vue')
			},
			{
				path: '/description',
				name: 'description',
				component: () => import('@/pages/xiangqing/description.vue')
			},
			{
				path: '/honorList',
				name: 'honorList',
				component: () => import('@/pages/xiangqing/honorList.vue')
			},
			{
				path: '/solution',
				name: 'solution',
				component: () => import('@/pages/xiangqing/solution.vue')
			},
			{
				path: '/aboutUs',
				name: 'aboutUs',
				component: () => import('@/pages/xiangqing/aboutUs.vue')
			},
			{
				path: '/decoration',
				name: 'decoration',
				component: () => import('@/pages/xiangqing/decoration.vue')
			},
			{
				path: '/caseDetails',
				name: 'caseDetails',
				component: () => import('@/pages/xiangqing/caseDetails.vue')
			}
		]
	}]
})
